import React from 'react'
import { Outlet } from 'react-router-dom'

const PrivateLayoutHeader = React.lazy(() => import('supplyLayout/PrivateLayoutHeader'))

const RootLayout = () => {

    return (
        <React.Suspense fallback= {<> </>}>
            <PrivateLayoutHeader />
            <Outlet />
        </React.Suspense>
    )
}

export default RootLayout